export default {
    loginPage:{
        'login': 'высадка ',
        'loggingIn': 'вход....',
        'customerPlatform':' клиентская платформа ',
        'sdyPlatform':'платформа сандайюнь ',    
    }
}